import runScripts from 'views/assets/scripts/runScripts'
import mountNewsletterUnsubscriptionContent from 'views/containers/browser/NewsletterUnsubscriptionFormContainer/mountNewsletterUnsubscriptionContent'

runScripts(mountNewsletterUnsubscriptionContent)
